import { getStoreId } from "$/hooks/use-store-information"
import customBookingSectionQueries from "$/lib/queries/custom-booking-section-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/custom-sections")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(customBookingSectionQueries.list({ storeId }))
    }

    return {
      crumb: "alfred.settings.nav.customSections.label",
    }
  },
})
